import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";


export class MailAccount extends Resource {
    public override type = 'mailAccounts';

    
  @prop()
  public isSystem: boolean = false;

  @prop()
  @required()
  public username: string = "";
  
  @prop()
  @required()
  public name!: string;

  @prop()
  @required()
  public password!: string;

  @prop()
  @required()
  public smtpEnabled: boolean = true;

  @prop()
  public smtpFrom?: string;
  
  @prop()
  public smtpFromName?: string;

  @prop()
  public smtpPort: number = 465;

  @prop()
  public smtpHost?: string;

  @prop()
  public smtpUseSSL: boolean = true;

  @prop()
  public imapEnabled: boolean = true;

  @prop()
  public imapHost?: string;

  @prop()
  public imapPort: number = 143;

  @prop()
  public imapUseSSL: boolean = true;
  @prop()
  public allowMailboxViewer: boolean = true;
  @prop()
  public unreadMailsCount: number = 0;
  @prop()
  public enableMailToCaseImport: boolean = false;
}